// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__GcM95","Logo":"Navbar_Logo__2jjF-","MainTitle":"Navbar_MainTitle__5ZVIk","Icons":"Navbar_Icons__5wQfy","Collapsed":"Navbar_Collapsed__2YXNG"};